module.exports = __webpack_public_path__ + "img/vakifkalitim.fc0ad871.png";